module.exports = __webpack_public_path__ + "img/public/AdminIcons/dashBoardListing.svg?490a718b";